module.exports = __webpack_public_path__ + "static/media/view6.50148574.jpg";